import applianceRuleApi from '@/api/appliance-rule'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const keyOf = x => {
  if (x.rkId !== null && x.rkId !== undefined) return `rk:${x.rkId}`
  if (x.deliveryGuid) return `guid:${x.deliveryGuid}`

  return `path:${x.path}`
}

const getDefaultState = () => ({
  id: 0,
  isEnabled: true,
  dishRkId: null,
  categoryKeys: [],

  quantity: 1,

  maxQuantity: 5,

  dishOptions: [],
  categoryOptions: [],

  savedCategories: [],

  errors: {},
})

const state = getDefaultState()

const getters = {}

const categories = () => state.categoryKeys
  .map(key => state.categoryOptions.find(x => x.key === key)
    ?? state.savedCategories.find(x => keyOf(x) === key))
  .filter(x => x)
  .map(x => ({ rkId: x.rkId ?? null, deliveryGuid: x.deliveryGuid ?? null, path: x.path ?? null }))

const payload = () => ({
  isEnabled: state.isEnabled,
  dishRkId: state.dishRkId,
  categories: categories(),
  quantity: Number(state.quantity),
  maxQuantity: Number(state.maxQuantity),
})

const actions = {
  fetchOptions({ commit }) {
    return applianceRuleApi.getOptions()
      .then(({ data }) => commit('OPTIONS_FETCHED', data))
      .catch(() => store.dispatch('message/error', 'PUSH_NOTIFICATION.failedFetch'))
  },
  async fetchById({ commit }, id) {
    commit('FORM_RESET')

    try {
      const { data } = await applianceRuleApi.getById(id)
      commit('FETCHED', data)
    } catch {
      store.dispatch('message/error', 'PUSH_NOTIFICATION.failedFetch')
    }
  },
  create({ commit }) {
    return applianceRuleApi.create(payload())
      .catch(error => {
        commit('SAVE_FAILED', error.response?.data)
        throw error
      })
  },
  update({ commit }) {
    return applianceRuleApi.update({ ...payload(), id: state.id })
      .catch(error => {
        commit('SAVE_FAILED', error.response?.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  OPTIONS_FETCHED(state, data) {
    state.dishOptions = data.dishes
    state.categoryOptions = data.categories.map(x => ({ ...x, key: keyOf(x) }))
  },
  FETCHED(state, data) {
    Object.assign(state, {
      id: data.id,
      isEnabled: data.isEnabled,
      dishRkId: data.dishRkId,
      savedCategories: data.categories || [],
      categoryKeys: (data.categories || []).map(keyOf),
      quantity: data.quantity,
      maxQuantity: data.maxQuantity,
    })
  },
  SAVE_FAILED(state, data) {
    state.errors = data?.validationErrors || {}
    store.dispatch('message/error', data?.message || 'PUSH_NOTIFICATION.failedUpdate')
  },
  FORM_RESET(state) {
    const fresh = getDefaultState()

    fresh.dishOptions = state.dishOptions
    fresh.categoryOptions = state.categoryOptions
    Object.assign(state, fresh)
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
